/**
 * created by xcc
 * 用户管理sys端
 *
 */


import {formateData, bodyHeader} from "./index";
import $ from "jquery"
import {applicationName} from "../utils";

export const headers = {
    Pragma: "no-cache",
    "Cache-Control": "no-cache",
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
};


//用户管理列表
export const getUserManagementListData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/list";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getUserManagementListData", error);
            callBack("");
        });
};
//左侧菜单列表
export const getLeftMenuData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/dept/all";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getLeftMenuData", error);
            callBack("");
        });
};

//重置密码返回的字符串
export const getResetPwdStr = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/getSecret";
    fetch(url, {
        method: "get",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getResetPwdStr", error);
            callBack("");
        });
};
//重置密码
export const getResetPwdData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/resetPwd";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getResetPwdData", error);
            callBack("");
        });
};

//得到密码级别
export const getPwdLevelData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/getCurrentLevel";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getPwdLevelData", error);
            callBack("");
        });
};

//禁用  解禁
export const getForbiddenData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/disableUser";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getForbiddenData", error);
            callBack("");
        });
};

//删除
export const getDeleteData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/delUser";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getDeleteData", error);
            callBack("");
        });
};


//获取媒体角色数据
export const getMediaRoleData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/mediaRole/list";
    fetch(url, {
        method: "get",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getMediaRoleData", error);
            callBack("");
        });
};

//获取角色数据
export const getRoleData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/role/list";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getRoleData", error);
            callBack("");
        });
};


//获取媒体数据
export const getMediaData = (codes, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/media/getMediaByCodes";
    $.post(url, codes, function (res) {
        callBack(res);
    })
};

//获取网站管理员数据
export const getWebsiteManagerData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/media/getWebsiteUserList";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getWebsiteManagerData", error);
            callBack("");
        });
};

//获取绑定AccountAndOwner
export const getByAccountAndOwner = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/getByAccountAndOwner";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getByAccountAndOwner", error);
            callBack("");
        });
};


//添加用户
export const getAddUserData = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/add";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:getAddUserData", error);
            callBack("");
        });
};

//修改用户
export const save = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/user/update";
    fetch(url, {
        method: "post",
        cache: "no-cache",
        headers: headers,
        credentials: "include",
        body: formateData(params),
    })
        .then((response) => response.json())
        .then((data) => {
            callBack(data);
        })
        .catch((error) => {
            console.error("actionError:save", error);
            callBack("");
        });
};

